import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useHostContext } from 'src/core/hooks/useHostContext';
import { DataHubService } from 'src/core/services/datahub';
import { ViewContentListSchema } from 'src/core/services/datahub/schemas/moduleList/viewContentListSchema';
import BulkActionsMenu from 'src/modules/contentList/components/bulkActions/bulkActionsMenu';
import { Header } from 'src/modules/contentList/components/header';
import { List } from 'src/modules/contentList/components/list';
import { Routes } from 'src/shared/constants/routes';
import { SurveyHelper } from 'src/shared/helpers/survey';
import { SurveyTriggerEvents } from 'src/shared/helpers/survey/constants';
export function ContentList() {
    const { contentListConceptToggle, bulkActionMenuToggle } = useHostContext();
    const location = useLocation();
    const [searchTerm, setSearchTerm] = useState('');
    const shouldRenderBulkActionsMenu = bulkActionMenuToggle &&
        !contentListConceptToggle &&
        location.pathname.endsWith(Routes.ListModules);
    useEffect(function invokeSurvey() {
        if (contentListConceptToggle) {
            SurveyHelper.invokeEvent(SurveyTriggerEvents.ContentList);
        }
    }, [contentListConceptToggle]);
    useEffect(function effectDispatchEvent() {
        if (contentListConceptToggle) {
            DataHubService.sendEvent({
                schema: new ViewContentListSchema({
                    arrivedFrom: window.location.href
                })
            });
        }
    }, [contentListConceptToggle]);
    return (_jsxs(_Fragment, { children: [shouldRenderBulkActionsMenu && _jsx(BulkActionsMenu, {}), contentListConceptToggle && (_jsxs("section", { children: [_jsx(Header, { onSearch: setSearchTerm }), _jsx(List, { searchTerm: searchTerm })] })), _jsx(Outlet, {})] }));
}
